export default "__VITE_ASSET__BXv4cp_O__"